<template>
    <div class="d-flex flex-align-center">
        <img
            :alt="item.content.title"
            :src="item.content.image"
            class="mr rounded overflow-hidden flex-child-fixed"
            style="width: 150px; height: 150px"
        />
        <div>
            <p class="text-bold mt-0">
                <a :href="item.url" target="_blank">
                    {{ item.content.title }}
                </a>
            </p>
            <p class="text-small text-secondary">{{ date }} - Duração de {{ duration }}</p>
            <p
                v-if="item.content.description"
                :class="{ 'line-clamp-3': !expanded }"
                class="text-secondary"
            >
                {{ item.content.description }}
            </p>
            <p class="text-small">
                <a class="text-primary cursor-pointer" @click="expanded = !expanded">
                    <span>
                        {{ expanded ? 'Ver menos' : 'Ver mais' }}
                        <i
                            :class="{
                                'icon-chevron-up': expanded,
                                'icon-chevron-down': !expanded,
                            }"
                            class="icon-cr"
                        />
                    </span>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CountryRegionPodcast',

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                expanded: false,
            };
        },

        computed: {
            duration() {
                return this.item.content ? this.msToTime(this.item.content.duration_ms) : null;
            },

            date() {
                return this.item.content
                    ? this.$f.formatDate(this.item.content.release_date)
                    : null;
            },
        },

        methods: {
            msToTime(duration) {
                let seconds = Math.floor((duration / 1000) % 60),
                    minutes = Math.floor((duration / (1000 * 60)) % 60),
                    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

                if (hours) hours = hours < 10 ? '0' + hours : hours;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                seconds = seconds < 10 ? '0' + seconds : seconds;

                return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
            },
        },
    };
</script>
